const Reflux = require('@muzzylane/reflux');
const isNumber = require('lodash/isNumber');
const isBoolean = require('lodash/isBoolean');
const isString = require('lodash/isString');
const isArray = require('lodash/isArray');
const isObject = require('lodash/isObject');
const map = require('lodash/map');
const has = require('lodash/has');

const ServerRequest = require('./request');
const ErrorConsts = require('../constants/error');
const ForgeError = require('../util/error');
const Strings = require('../../../app/shared/Strings');
const Globals = require('../../../app/globals');

const AssignmentActions = Reflux.createActions({
    resetAssnStoreState: { children: ['completed'] },
    clearAssignment: { children: ['completed', 'failed'] },
    getAssignment: { children: ['completed', 'failed'] },
    getAssignmentActivity: { children: ['completed', 'failed'] },
    getAssignmentTurnStatus: { children: ['completed', 'failed'] },
    playAssignment: { children: ['completed', 'failed'] },
    setupAssignment: { children: ['completed', 'failed'] },
    archiveAssignment: { children: ['completed', 'failed'] },
    getLtiAssignmentsForUser: { children: ['completed', 'failed'] },
    getLocalAssignmentMinimal: { children: ['completed', 'failed'] },
    authorizeLocalAssignmentUser: { children: ['completed', 'failed'] },
    authorizeLocalAssignmentAccessCode: { children: ['completed', 'failed'] },
    getLocalAssignments: { children: ['started', 'completed', 'failed'] },
    getLtiAssignmentStats: { children: ['completed', 'failed'] },
    forceEndTurn: { children: ['completed', 'failed'] },
    setupConnectAssignmentActivity: { children: ['completed', 'failed'] },
    setupConnectAssignmentPolicy: { children: ['completed', 'failed'] },
    adminGetUserAssignments: { children: ['started', 'completed', 'failed'] },
    adminGetStudentCountPerIntegrationType: { children: ['started', 'completed', 'failed'] },
    resendConnectAssignmentScore: { children: ['completed', 'failed'] },
    resendVantageAssignmentScore: { children: ['completed', 'failed'] },
    submitMultiActivityAssignmentAttempt: { children: ['completed', 'failed'] },
    addAssignmentAdmin: { children: ['completed', 'failed'] },
    getAssignmentWeights: { children: ['completed', 'failed'] },
    getAssignmentMetaOptions: { children: ['completed', 'failed'] },
    getLtiDiagnostics: { children: ['completed', 'failed'] },
    getSectionRoster: { children: ['completed', 'failed']},
    getUserAttemptHistory: { children: ['completed', 'failed']},
    getAdminSendScoresErrors: { children: ['completed', 'failed'] },
    getAdminSendScoresError: { children: ['completed', 'failed'] },
});

AssignmentActions.getAssignment.listen(function(actionId, params) {
    if (!params.assignmentHash) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    const disableAutoLogout = true; // otherwise makeRequest causes a redirect to the /signin page
    const data = {
        studentPage: params.studentPage || 1,
        studentSearch: params.studentSearch || '',
        studentIdSearch: params.studentIdSearch || '',
    };
    if (params.isPolicyPage) {
        data.isPolicyPage = true;
    }
    
    ServerRequest.makeRequest(`/authoring/assignment/${params.assignmentHash}`, 'POST', JSON.stringify(data), disableAutoLogout)
        .then(res => this.completed(actionId, res))
        .catch(err => this.failed(actionId, err));
});

AssignmentActions.getAssignmentActivity.listen(function(actionId, params) {
    if (!params.assignmentHash) {
        this.failed(actionId, params.assignmentHash, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/assignment/${params.assignmentHash}/activity`, 'GET')
        .then(res => this.completed(actionId, params.assignmentHash, res))
        .catch(err => this.failed(actionId, params.assignmentHash, err));
});

AssignmentActions.getAssignmentTurnStatus.listen(function(actionId, params) {
    if (!params.assignmentHash) {
        this.failed(actionId, params.assignmentHash, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/assignment/${params.assignmentHash}/turn_status`, 'GET')
        .then(res => this.completed(actionId, params.assignmentHash, res))
        .catch(err => this.failed(actionId, params.assignmentHash, err));
});

AssignmentActions.resetAssnStoreState.listen(function(actionId, params) {
    this.completed(actionId, params);
});

AssignmentActions.clearAssignment.listen(function(actionId, params) {
    this.completed(actionId, params);
});

// params.integrationType is only needed for Connect and Vantage assignments.
// ...both standard LTI and Local will work with same API (omitted params.integrationType)
AssignmentActions.playAssignment.listen(function(actionId, params) {
    if (!params.assignmentHash) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (params.integrationType === Globals.integration_type.CONNECT) {
        if (!params.contentType || params.contentType === Globals.assignment.content_type.ACTIVITY) {
            if (!params.attempt) {
                this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
                return;
            }
    
            ServerRequest.makeRequest(`/authoring/connect/assignment/${params.assignmentHash}/play/${params.attempt}`, 'POST', JSON.stringify({}))
                .then(res => this.completed(actionId, params.assignmentHash, res))
                .catch(err => this.failed(actionId, err));
        }
        else if (params.contentType === Globals.assignment.content_type.MULTI_ACTIVITY) {
            if (!params.attempt) {
                this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
                return;
            }

            if (!params.assnActId) {
                this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
                return;
            }

            if (!params.retry) {
                this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
                return;
            }
    
            ServerRequest.makeRequest(
                    `/authoring/connect/assignment/${params.assignmentHash}/play/${params.attempt}/${params.assnActId}/${params.retry}`,
                    'POST',
                    JSON.stringify({})
                )
                .then(res => this.completed(actionId, params.assignmentHash, res))
                .catch(err => this.failed(actionId, err));
        }
        else {
            this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
            return;
        }

    }
    else if (params.integrationType === Globals.integration_type.VANTAGE) {
        if (!params.attempt) {
            this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
            return;
        }

        ServerRequest.makeRequest(`/authoring/vantage/assignment/${params.assignmentHash}/play/${params.attempt}`, 'POST', JSON.stringify({}))
            .then(res => this.completed(actionId, params.assignmentHash, res))
            .catch(err => this.failed(actionId, err));
    }
    else if (!params.novaActInstId) {
        ServerRequest.makeRequest(`/authoring/assignment/${params.assignmentHash}/play`, 'POST', JSON.stringify({}))
            .then(res => this.completed(actionId, params.assignmentHash, res))
            .catch(err => this.failed(actionId, err));
    }
    else { //admin requests must specify novaActInstId for any given assignment
        ServerRequest.makeRequest(`/authoring/assignment/${params.assignmentHash}/${params.novaActInstId}/play`, 'POST', JSON.stringify({}))
            .then(res => this.completed(actionId, params.assignmentHash, res))
            .catch(err => this.failed(actionId, err));
    }

});

AssignmentActions.setupAssignment.listen(function(actionId, params) {
    if (!params.assignmentHash) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    //sanitize
    const assignmentParams = {
        activityId: isNumber(parseInt(params.activityId, 10)) ? parseInt(params.activityId, 10) : null,
        maxAttempts: isNumber(parseInt(params.maxAttempts, 10)) ? parseInt(params.maxAttempts, 10) : null,
        allowUnlimitedAttempts: isBoolean(params.unlimitedAttempts) ? params.unlimitedAttempts : null,
        allowRestart: isBoolean(params.allowRestart) ? params.allowRestart : null,
        scoreType: isString(params.scoreType) ? params.scoreType: null,
        start_date: params.start_date ? params.start_date.format('YYYY-MM-DD HH:mm:ssZ') : '',
        end_date: params.end_date ? params.end_date.format('YYYY-MM-DD HH:mm:ssZ') : '',
    }

    if (!params.isMultiplayer) {
        ServerRequest.makeRequest(`/authoring/assignment/${params.assignmentHash}/setup`, 'POST', JSON.stringify(assignmentParams))
            .then(res => this.completed(actionId, params.assignmentHash, res))
            .catch(err => this.failed(actionId, err));
    }
    else {
        assignmentParams.games = params.userGroupings;
        assignmentParams.turn_dates = map(params.turnDates, (turnDate) => {
            return turnDate.turn_date.format('YYYY-MM-DD HH:mm:ssZ'); //convert to moment object to server expected format
        });
        ServerRequest.makeRequest(`/authoring/assignment/${params.assignmentHash}/multiplayer/setup`, 'POST', JSON.stringify(assignmentParams))
            .then(res => this.completed(actionId, params.assignmentHash, res))
            .catch(err => this.failed(actionId, err));
    }
});

AssignmentActions.archiveAssignment.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/assignment/${params.hash}/archive`, 'POST')
        .then(res => this.completed(actionId, params.hash, res))
        .catch(err => this.failed(actionId, err));
});

AssignmentActions.getLocalAssignmentMinimal.listen(function(actionId, params) {
    ServerRequest.makeRequest(
            `/authoring/mzl/${params.assignmentHash}`
            ,
            'GET'
        )
        .then(res => this.completed(actionId, params.assignmentHash, res))
        .catch(err => this.failed(actionId, err));
});

AssignmentActions.authorizeLocalAssignmentUser.listen(function(actionId, params) {
    let uri;
    if (params.isInstructor) {
        uri = '/authoring/mzl_instructor';
    }
    else {
        uri = '/authoring/mzl';
    }

    ServerRequest.makeRequest(uri, 'POST', JSON.stringify({
            userProfile: params.userProfile,
            assignmentHash: params.assignmentHash,
            group_id: params.group_id,
            manualAccessCode: params.manualAccessCode,
            accessCodeName: params.accessCodeName,
        }))
        .then(res => this.completed(actionId, params.assignmentHash, res))
        .catch(err => this.failed(actionId, err))
});

AssignmentActions.authorizeLocalAssignmentAccessCode.listen(function(actionId, params) {
    ServerRequest.makeRequest('/authoring/mzl', 'POST', JSON.stringify({
            accessCode: params.accessCode,
            assignmentHash: params.assignmentHash,
            manualEntry: params.manualEntry,
        }))
        .then(res => this.completed(actionId, params.assignmentHash, res))
        .catch(err => this.failed(actionId, err));
});

AssignmentActions.getLocalAssignments.listen(function(actionId) {
    this.started(actionId);
    ServerRequest.makeRequest('/authoring/assignments/mzl', 'GET')
        .then(res => this.completed(actionId, res))
        .catch(err => this.failed(actionId, err));
});

//ADMIN
AssignmentActions.getLtiAssignmentsForUser.listen(function(actionId, params) {
    if (!params.userId) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/assignment/partner/${params.userId}/details`, 'GET')
        .then(res => this.completed(actionId, params.userId, res))
        .catch(err => this.failed(actionId, params.userId, err));
});

//ADMIN
AssignmentActions.getLtiAssignmentStats.listen(function(actionId, params) {
    if (!params.assignmentHash) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeTaskRequest(`/authoring/assignment/${params.assignmentHash}/stats`, 'GET')
        .then(res => this.completed(actionId, params.assignmentHash, res))
        .catch(err => this.failed(actionId, params.assignmentHash, err));
});

//ADMIN
AssignmentActions.adminGetUserAssignments.listen(function(actionId, params) {
    const userId = params.id;
    if (!userId) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    this.started(actionId, userId);
    ServerRequest.makeRequest(`/authoring/user_assignments/${userId}`, 'GET')
        .then(res => this.completed(actionId, userId, res))
        .catch(err => this.failed(actionId, userId, err));
});

//ADMIN
AssignmentActions.adminGetStudentCountPerIntegrationType.listen(function(actionId, params) {
    const userId = params.id;
    if (!userId) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    this.started(actionId, userId);
    ServerRequest.makeTaskRequest(`/authoring/student_counts_per_integration/${userId}`, 'GET')
        .then(res => this.completed(actionId, userId, res))
        .catch(err => this.failed(actionId, userId, err));
});

AssignmentActions.forceEndTurn.listen(function(actionId, params) {
    if (!params.assignmentHash) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    const reqBody = {};
    if (params.turnNum) { // server will validate turn to end
        reqBody.turn_num = params.turnNum;
    }

    ServerRequest.makeRequest(`/authoring/assignment/${params.assignmentHash}/force_turn`, 'POST', JSON.stringify(reqBody))
        .then(res => this.completed(actionId, params.assignmentHash, res))
        .catch(err => this.failed(actionId, params.assignmentHash, err));
});


AssignmentActions.setupConnectAssignmentActivity.listen(function(actionId, params) {
    if (!params.assignmentHash) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    let assignmentParams;
    //sanitize
    if (!params.contentType || params.contentType === Globals.assignment.content_type.ACTIVITY) {
        assignmentParams = {
            contentType: Globals.assignment.content_type.ACTIVITY,
            activityId: isNumber(parseInt(params.activityId, 10)) ? parseInt(params.activityId, 10) : null,
        };

        if (typeof params.completionScoringEnabled === 'boolean') {
            assignmentParams.completionScoringEnabled = params.completionScoringEnabled;
        }
    }
    else if (params.contentType === Globals.assignment.content_type.MULTI_ACTIVITY) {
        if (!isArray(params.activityIds)) {
            this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        }

        assignmentParams = {
            contentType: Globals.assignment.content_type.MULTI_ACTIVITY,
            activityIds: params.activityIds.map(activityId => isNumber(parseInt(activityId, 10)) ? parseInt(activityId, 10) : null),
        };

        if (isObject(params.completionScoringEnabled)) {
            assignmentParams.completionScoringEnabled = params.completionScoringEnabled;
        }
    }
    else { // unrecognized content type
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(
            `/authoring/connect/assignment/${params.assignmentHash}/setup/activity?actionId=${actionId}`,
            'POST',
            JSON.stringify(assignmentParams)
        )
        .then(res => this.completed(actionId, params.assignmentHash, res))
        .catch(err => this.failed(actionId, err));
});


AssignmentActions.setupConnectAssignmentPolicy.listen(function(actionId, params, manager) {
    if (!params.assignmentHash) {
        this.failed(actionId, params.assignmentHash, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    let assignmentParams = {};
    if (!params.contentType || params.contentType === Globals.assignment.content_type.ACTIVITY) {
        if (params.weights) {
            assignmentParams.weights = params.weights;
        }
    
        if (params.turnEvents) {
            assignmentParams.turnEvents = params.turnEvents;
        }
    
        if (has(params, 'tutorialEnabled')) {
            assignmentParams.tutorialEnabled = params.tutorialEnabled;
        }
    
        if (has(params, 'partialGoalScoringEnabled')) {
            assignmentParams.partialGoalScoringEnabled = params.partialGoalScoringEnabled;
        }
    
        if (has(params, 'completionScoringEnabled')) {
            assignmentParams.completionScoringEnabled = params.completionScoringEnabled;
        }
    
        if (params.optionalContent) {
            assignmentParams.optionalContent = params.optionalContent;
        }
    
        if (params.gameGroupingsUser) {
            assignmentParams.gameGroupingsUser = params.gameGroupingsUser;
            assignmentParams.gameGroupingsUserEdited = false;
            if (typeof params.gameGroupingsUserEdited === 'boolean') {
                assignmentParams.gameGroupingsUserEdited = params.gameGroupingsUserEdited;
            }
        }
    
        if (params.gameGroupingsTeam) {
            assignmentParams.gameGroupingsTeam = params.gameGroupingsTeam;
            assignmentParams.gameGroupingsTeamEdited = false;
            if (typeof params.gameGroupingsTeamEdited === 'boolean') {
                assignmentParams.gameGroupingsTeamEdited = params.gameGroupingsTeamEdited;
            }
        }
    
        if (params.teamGroupings) {
            assignmentParams.teamGroupings = params.teamGroupings;
            assignmentParams.teamGroupingsEdited = false;
            if (typeof params.teamGroupingsEdited === 'boolean') {
                assignmentParams.teamGroupingsEdited = params.teamGroupingsEdited;
            }
        }
    
        if (typeof params.numTurns === 'number') {
            assignmentParams.numTurns = params.numTurns;
        }
    
        if (params.turnType) {
            assignmentParams.turnType = params.turnType;
        }
    
        if (params.startDate) {
            assignmentParams.startDate = params.startDate;
        }
    
        if (params.endDate) {
            assignmentParams.endDate = params.endDate;
        }
    
        if (params.turnEndingsEdited) assignmentParams.turnEndingsEdited = params.turnEndingsEdited;
        if (params.turnEndingDays) assignmentParams.turnEndingDays = params.turnEndingDays;
        if (params.turnEndingMinute) assignmentParams.turnEndingMinute = params.turnEndingMinute;
        if (params.turnEndingHour) assignmentParams.turnEndingHour = params.turnEndingHour;
        if (params.turnEndingTimezone) assignmentParams.turnEndingTimezone = params.turnEndingTimezone;
    
        if (typeof params.openEnrollmentEnabled === 'boolean') {
            assignmentParams.openEnrollmentEnabled = params.openEnrollmentEnabled;
        }
    
        if (params.openEnrollmentConfig) {
            assignmentParams.openEnrollmentConfig = params.openEnrollmentConfig;
        }

    }
    else if (params.contentType === Globals.assignment.content_type.MULTI_ACTIVITY) {
        if (!isObject(params.actPolicies)) {
            this.failed(actionId, params.assignmentHash, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
            return;
        }

        if (typeof params.multiOrderLocked !== 'boolean') {
            this.failed(actionId, params.assignmentHash, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
            return;
        }

        assignmentParams = { multi_order_locked: params.multiOrderLocked };

        // act_policies format:
        // {
        //   [activityId]: {
        //      weight: [number], (0-100, max precision 2)
        //      display_order: [number], (0-99)
        //      attempts: [number], (1, 2, or -1 for unlimited)
        //      meta_options: {
        //          [meta_option_name]: [meta_option_value], (allowed: completionScoringEnabled)
        //         ...,
        //      },
        //   }
        // }
        if (!isObject(params.actPolicies)) { // TODO validate further?
            this.failed(actionId, params.assignmentHash, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
            return; 
        }

        assignmentParams.act_policies = params.actPolicies;
    }
    else { // unrecognized content type
        this.failed(actionId, params.assignmentHash, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makePollTaskRequest(
            `/authoring/connect/assignment/${params.assignmentHash}/setup/policy`,
            'POST', JSON.stringify(assignmentParams),
            manager,
            actionId
        )
        .then(res => this.completed(actionId, params.assignmentHash, res))
        .catch(err => this.failed(actionId, params.assignmentHash, err));
});

AssignmentActions.resendConnectAssignmentScore.listen(function(actionId, params) {
    if (!params.assignmentHash || !params.studentId || !params.attemptId) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    return ServerRequest.makeRequest(
            `/authoring/connect/assignment/${params.assignmentHash}/student/${params.studentId}/attempt/${params.attemptId}/resendScore`,
            'POST',
            JSON.stringify({})
        )
        .then(res => this.completed(actionId, params.assignmentHash, params.attemptId, params.studentId, res))
        .catch(err => this.failed(actionId, params.assignmentHash, params.attemptId, params.studentId, err));
});

AssignmentActions.resendVantageAssignmentScore.listen(function(actionId, params) {
    if (!params.assignmentHash || !params.studentId || !params.attemptId) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    return ServerRequest.makeRequest(
            `/authoring/vantage/assignment/${params.assignmentHash}/student/${params.studentId}/attempt/${params.attemptId}/resendScore`,
            'POST',
            JSON.stringify({})
        )
        .then(res => this.completed(actionId, params.assignmentHash, params.attemptId, params.studentId, res))
        .catch(err => this.failed(actionId, params.assignmentHash, params.attemptId, params.studentId, err));
});

AssignmentActions.submitMultiActivityAssignmentAttempt.listen(function(actionId, params) {
    if (!params.assignmentHash || !params.attemptNum) {
        this.failed(actionId, params.assignmentHash, params.attemptNum, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    return ServerRequest.makeRequest(
            `/authoring/connect/assignment/${params.assignmentHash}/submit/${params.attemptNum}`,
            'POST',
            JSON.stringify({})
        )
        .then(res => this.completed(actionId, params.assignmentHash, params.attemptNum, res))
        .catch(err => this.failed(actionId, params.assignmentHash, params.attemptNum, err));
});

AssignmentActions.addAssignmentAdmin.listen(function (actionId, params) {
    if (!params.assignmentHash) {
        this.failed(actionId, params.assignmentHash, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    let postBody = {};
    if (params.integrationType) {
        postBody.integrationType = params.integrationType;
    }

    return ServerRequest.makeRequest(
            `/authoring/assignment/${params.assignmentHash}/add_admin`,
            'POST',
            JSON.stringify(postBody)
        )
        .then(res => this.completed(actionId, params.assignmentHash, res))
        .catch(err => this.failed(actionId, params.assignmentHash, err));
});

AssignmentActions.getAssignmentWeights.listen(function(actionId, params) {
    if (!params.assignmentHash) {
        this.failed(actionId, null, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    const disableAutoLogout = true;
    return ServerRequest.makeRequest(`/authoring/assignment/${params.assignmentHash}/weights`, 'GET', null, disableAutoLogout)
        .then(res => this.completed(actionId, params.assignmentHash, res))
        .catch(err => this.failed(actionId, params.assignmentHash, err));
});

AssignmentActions.getAssignmentMetaOptions.listen(function(actionId, params) {
    if (!params.assignmentHash) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    return ServerRequest.makeRequest(`/authoring/assignment/${params.assignmentHash}/meta_options`, 'GET')
        .then(res => this.completed(actionId, params.assignmentHash, res))
        .catch(err => this.failed(actionId, params.assignmentHash, err));
});

AssignmentActions.getLtiDiagnostics.listen(function(actionId, params) {
    if (!params.assignmentHash) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    return ServerRequest.makeRequest(`/authoring/assignment/${params.assignmentHash}/lti_diagnostics`, 'GET')
        .then(res => this.completed(actionId, params.assignmentHash, res))
        .catch(err => this.failed(actionId, params.assignmentHash, err));
});

AssignmentActions.getSectionRoster.listen(function(actionId, params) {
    if (!params.assignmentHash || !params.assignmentType) {
        this.failed(actionId, params.assignmentHash, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (params.assignmentType === Globals.integration_type.CONNECT) {
        return ServerRequest.makeRequest(`/authoring/connect/assignment/${params.assignmentHash}/section_roster`, 'GET')
            .then(res => this.completed(actionId, params.assignmentHash, res))
            .catch(err => this.failed(actionId, params.assignmentHash, err));
    }
    else {
        this.failed(actionId, new ForgeError({ message: Strings['en'].assignment.NOT_AVAIL_FOR_ASSN_TYPE }));
        return;
    }

});

AssignmentActions.getUserAttemptHistory.listen(function(actionId, params) {
    if (!params.assignmentHash) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (!params.userAttemptId) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    return ServerRequest.makeRequest(`/authoring/assignment/${params.assignmentHash}/user_attempt_statuses/${params.userAttemptId}`, 'GET')
        .then(res => this.completed(actionId, params.assignmentHash, params.userAttemptId, res))
        .catch(err => this.failed(actionId, params.assignmentHash, params.userAttemptId, err));
});

// ADMIN
AssignmentActions.getAdminSendScoresErrors.listen(function(actionId) {
    ServerRequest.makeRequest(`/authoring/assignment/score_error_attempts`, 'GET')
        .then(res => this.completed(actionId, res))
        .catch(err => this.failed(actionId, err));
});

// ADMIN
AssignmentActions.getAdminSendScoresError.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/assignment/score_error_attempts/${params.userAttemptId}`, 'GET')
        .then(res => this.completed(actionId, params.userAttemptId, res))
        .catch(err => this.failed(actionId, params.userAttemptId, err));
});

module.exports = AssignmentActions;
